import { useAtomValue } from 'jotai'
import { listGroupLabel } from '@highlight/ui'
import { twMerge } from 'tailwind-merge'
import { MentionableItem } from '../../../../../types'
import { selectedMentionIndexAtom } from '../atoms'
import type { MentionSection } from '../hooks/use-filtered-mention-data'
import { MentionableRow } from './mentionable-row'
import { MentionSectionHeading } from './mention-list-parts'

/** One labelled block of the menu, highlighted against the flat navigation index. */
export const MentionableSection = ({
  section,
  onSelect,
}: {
  section: MentionSection
  onSelect: (mention: MentionableItem) => void
}) => {
  const mentionIndex = useAtomValue(selectedMentionIndexAtom)
  return (
    <>
      <div className={twMerge(listGroupLabel, 'flex justify-between')}>
        <MentionSectionHeading section={section} />
      </div>
      {section.items.map((mention, index) => (
        <MentionableRow
          key={mention.value}
          mention={mention}
          isSelected={mentionIndex === index + section.offset}
          onSelect={onSelect}
        />
      ))}
    </>
  )
}
